import { v4 as uuidv4 } from 'uuid';
import { Message, Chat } from '../../models';

// Definir el slice como un objeto plano
const chatSlice = (set, get) => ({
  // Chat actualmente activo
  activeChat: null,
  
  // Si el agente está escribiendo
  isTyping: false,
  
  // Crear un nuevo chat (reemplaza el chat activo)
  createNewChat: (agentKey) => {
    const newChat = new Chat({
      agentKey,
      title: 'Nuevo chat',
      messages: []
    });
    set({ activeChat: newChat });
    return newChat;
  },

  // Establecer el chat activo (no busca en historial)
  setActiveChat: (chat) => {
    set({ activeChat: chat });
    return chat;
  },
  
  // Agregar un mensaje al chat actual
  addMessage: (message, isUser = true, metadata = {}) => {
    const { activeChat } = get();
    if (!activeChat) return null;
    
    const newMessage = new Message({
      text: message,
      sender: isUser ? 'user' : 'assistant',
      metadata
    });
    
    const updatedChat = activeChat.addMessage(newMessage);
    
    set({
      activeChat: updatedChat
    });
    
    return newMessage;
  },
  
  // Enviar un mensaje al agente activo
  sendMessage: async (message, context = {}) => {
    const { activeChat, addMessage } = get();
    if (!activeChat) {
      console.error('No hay un chat activo');
      return null;
    }
    
    // Obtener el agente activo del estado global
    const state = get();
    const { activeAgent, selectedAgent } = state;
    
    if (!activeAgent || !selectedAgent) {
      console.error('No hay un agente activo seleccionado');
      return null;
    }
    
    // Obtener el nombre del usuario autenticado desde el estado
    const { userId, userProfile } = get();
    const userName = userProfile?.name || 'Usuario';
    
    // Agregar mensaje del usuario con el sessionId y el nombre de usuario en el contexto
    const userMessage = addMessage(message, true, {
      ...context,
      sessionId: activeChat.sessionId,
      timestamp: new Date().toISOString(),
      agentId: selectedAgent,
      // Incluir el nombre del usuario en los metadatos
      userName: userName
    });
    
    // Indicar que el agente está escribiendo
    set({ isTyping: true });
    
    try {
      // Enviar mensaje al agente con el sessionId
      const response = await activeAgent.sendMessage(message, {
        ...context,
        chatId: activeChat.id,
        sessionId: activeChat.sessionId,
        timestamp: new Date().toISOString(),
        agentId: selectedAgent
      });
      
      // Agregar respuesta del agente
      const botMessage = addMessage(
        response.response || 'Lo siento, no pude procesar tu mensaje.',
        false,
        { 
          ...response.metadata, 
          success: response.success,
          agentId: selectedAgent
        }
      );
      
      return botMessage;
    } catch (error) {
      console.error('Error al enviar mensaje al agente:', error);
      const errorMessage = addMessage(
        'Lo siento, hubo un error al procesar tu mensaje. Por favor, inténtalo de nuevo más tarde.',
        false,
        { 
          error: true, 
          errorMessage: error.message,
          agentId: selectedAgent
        }
      );
      return errorMessage;
    } finally {
      set({ isTyping: false });
    }
  },
  
  // Establecer el estado de "escribiendo"
  setIsTyping: (isTyping) => {
    set({ isTyping });
  },
  
  // Actualizar el título de un chat
  updateChatTitle: (chatId, newTitle) => {
    set(state => {
      const updatedChats = state.chats.map(chat => {
        if (chat.id === chatId) {
          return { ...chat, title: newTitle };
        }
        return chat;
      });
      
      return {
        chats: updatedChats,
        activeChat: state.activeChat?.id === chatId 
          ? { ...state.activeChat, title: newTitle }
          : state.activeChat
      };
    });
  },
  
  // Eliminar un chat
  deleteChat: (chatId) => {
    set(state => {
      const updatedChats = state.chats.filter(chat => chat.id !== chatId);
      const newActiveChat = state.activeChat?.id === chatId 
        ? updatedChats[0] || null 
        : state.activeChat;
      
      return {
        chats: updatedChats,
        activeChat: newActiveChat,
        showChat: !!newActiveChat
      };
    });
  }
});

export default chatSlice;